module.exports = __webpack_public_path__ + "static/media/Tomato.242491fc.png";